import { TOTAL_WEEKS } from "../content/course_static";

const KEY = "nofap27_progress_v1";

function defaultState() {
  return {
    currentWeek: 0, // 0 = Intro, 1..TOTAL_WEEKS = course weeks
    completedWeeks: [],
    skippedWeeks: [],
    notes: {}, // {"0": "note for intro", "1": "note for week1"}
    updatedAt: Date.now(),
  };
}

export function loadProgress() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return defaultState();
    const data = JSON.parse(raw);
    return { ...defaultState(), ...data };
  } catch (e) {
    console.error("Failed to parse progress. Resetting.", e);
    return defaultState();
  }
}

export function saveProgress(state) {
  const toSave = { ...state, updatedAt: Date.now() };
  localStorage.setItem(KEY, JSON.stringify(toSave));
  return toSave;
}

export function setCurrentWeek(week) {
  const s = loadProgress();
  s.currentWeek = Math.max(0, Math.min(TOTAL_WEEKS, week));
  return saveProgress(s);
}

export function completeWeek(week) {
  const s = loadProgress();
  const set = new Set(s.completedWeeks);
  set.add(week);
  s.completedWeeks = Array.from(set).sort((a, b) => a - b);
  s.currentWeek = Math.min(TOTAL_WEEKS, Math.max(s.currentWeek, week + 1));
  return saveProgress(s);
}

export function skipWeek(week) {
  const s = loadProgress();
  const set = new Set(s.skippedWeeks);
  set.add(week);
  s.skippedWeeks = Array.from(set).sort((a, b) => a - b);
  s.currentWeek = Math.min(TOTAL_WEEKS, Math.max(s.currentWeek, week + 1));
  return saveProgress(s);
}

export function saveNote(week, text) {
  const s = loadProgress();
  s.notes = s.notes || {};
  s.notes[String(week)] = text;
  return saveProgress(s);
}

export function resetProgress() {
  const s = defaultState();
  return saveProgress(s);
}

// New: uncomplete a previously completed week (used when undoing today's check on the 7th day)
export function uncompleteWeek(week) {
  const s = loadProgress();
  const set = new Set(s.completedWeeks);
  if (set.has(week)) {
    set.delete(week);
    s.completedWeeks = Array.from(set).sort((a, b) => a - b);
    // if currentWeek moved past this week due to completion, allow moving back
    if (s.currentWeek > week) s.currentWeek = week; // keep simple; gating still enforced elsewhere
    return saveProgress(s);
  }
  return s;
}